import { useState } from "react";

import KeyToggleButton from "./KeyToggleButton";

const DefaultZoomWrapper = ({ children, style }) => (
  <div style={{ lineHeight: 0, ...style }}>{children}</div>
);

const DiagramWithToggleKey = ({
  CombinedDiagram,
  keyControlsId,
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  zoomScale = 1,
  hideKeyToggle = false,
  showKey: controlledShowKey,
  onShowKeyChange,
  zoomContentRef,
  ZoomWrapper = DefaultZoomWrapper,
  ...props
}) => {
  const [internalShowKey, setInternalShowKey] = useState(true);
  const showKey = controlledShowKey ?? internalShowKey;
  const setShowKey = onShowKeyChange ?? setInternalShowKey;

  return (
    <div
      {...props}
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        lineHeight: 0,
        ...props.style
      }}
    >
      {!hideKeyToggle ? (
        <div
          style={{ lineHeight: "normal", marginBottom: 8, flexShrink: 0 }}
          onPointerDown={event => event.stopPropagation()}
          onWheel={event => event.stopPropagation()}
        >
          <KeyToggleButton
            showKey={showKey}
            controlsId={keyControlsId}
            onChange={setShowKey}
          />
        </div>
      ) : null}
      <ZoomWrapper style={{ width: "100%" }}>
        <div
          ref={zoomContentRef}
          style={{
            width: `${zoomScale * 100}%`,
            marginInline: "auto",
            lineHeight: 0
          }}
        >
          <CombinedDiagram
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            showKey={showKey}
            keyControlsId={keyControlsId}
            onGeneClick={onGeneClick}
            data-diagram-main
            width="100%"
            height="auto"
          />
        </div>
      </ZoomWrapper>
    </div>
  );
};

export default DiagramWithToggleKey;
